// AuthContext is populated from the backend /auth/me response. Keep clinician
// navigation authorization tied to that canonical role value, never UI labels.
export const isPsychologistUser = (user) => user?.role === 'psychologist';

export const isPhaseTabDisabled = ({ user, phase, currentPhase, reportsOnly = false, hasSynthesis = false }) => {
  if (isPsychologistUser(user)) return false;

  // Preserve the existing client sequence exactly. Reports remain readable.
  if (user?.role === 'client' && phase >= 2 && phase <= 4) {
    return (currentPhase || 0) < (phase - 1);
  }
  return false;
};
